import { render, staticRenderFns } from "./EditExamModal.vue?vue&type=template&id=2b7b04e9&scoped=true&"
import script from "./EditExamModal.vue?vue&type=script&lang=js&"
export * from "./EditExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b04e9",
  null
  
)

export default component.exports